import React from 'react';
import { LazyComponent } from '@fiverr-private/seller_pages_toolbox';

const lazyImport = () => import(/* webpackChunkName: 'UserActivationModal' */ '@fiverr-private/user_activation');

const UserActivationModalLazy = (props) => (
    <LazyComponent lazyImport={lazyImport} componentProps={props} moduleName="UserActivationModal" />
);

export default UserActivationModalLazy;
